// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/cycle_day_effect.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schedules/v1/resources/cycle_day_effect.proto.
 */
export const file_studyo_today_schedules_v1_resources_cycle_day_effect = /*@__PURE__*/
  fileDesc("CjpzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9jeWNsZV9kYXlfZWZmZWN0LnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyqEAQoOQ3ljbGVEYXlFZmZlY3QSIAocQ1lDTEVfREFZX0VGRkVDVF9VTlNQRUNJRklFRBAAEhkKFUNZQ0xFX0RBWV9FRkZFQ1RfUFVTSBABEhkKFUNZQ0xFX0RBWV9FRkZFQ1RfU0tJUBACEhoKFkNZQ0xFX0RBWV9FRkZFQ1RfUkVTRVQQA0IrqgIoU3R1ZHlvLlRvZGF5LlNjaGVkdWxlcy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schedules.v1.resources.CycleDayEffect.
 */
export const CycleDayEffectSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schedules_v1_resources_cycle_day_effect, 0);

/**
 * The possible effects of a special day on the cycle day.
 *
 * @generated from enum studyo.today.schedules.v1.resources.CycleDayEffect
 */
export const CycleDayEffect = /*@__PURE__*/
  tsEnum(CycleDayEffectSchema);

